import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import { Line, Pie, Bar } from 'react-chartjs-2';
import * as url from "url";

class chart extends React.Component {

    state = {
        loading: true,
        userData: null,
        error: null
    };
    
    //urllocal = 'http://127.0.0.1:5000/'
    url_cloud = 'https://iot-temphumid.herokuapp.com/'

    async componentDidMount() {
        try {
            const responseHumidity = await fetch(this.url_cloud + 'humidity', {
                credentials: 'include',
            });

            const responseTemperature = await fetch(this.url_cloud +'temperature', {
                credentials: 'include',
            });

            const jsonTemperature = await responseTemperature.json();
            const jsonHumidity = await responseHumidity.json();

            this.setState({
                loading: false,
                humidity: jsonHumidity,
                temperature: jsonTemperature
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error
            });
        }
    }

    render() {
        const { loading, humidity, temperature, error } = this.state;
        if (loading) return <p>Loading...</p>;
        if (error) return <p>{error.message}</p>;
        const timeArray = humidity.map(humidity => humidity.taken_at);
        const humidityArray = humidity.map(humidity => humidity.humidity);
        const temperatureArray = temperature.map(temperature => temperature.temperature);
        const data = {
            labels: //hours ,
                timeArray.map(time => {
                    const date = new Date(time);
                    const hours = date.getHours();
                    const minutes = date.getMinutes();
                    const seconds = date.getSeconds();
                    return `${hours}:${minutes}:${seconds}`;
                }),
            datasets: [
                {
                    //blue color
                    label: 'Humidity',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: humidityArray
                },
                {
                    //red color
                    label: 'Temperature',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(255,99,132,0.4)',
                    borderColor: 'rgba(255,99,132,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(255,99,132,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(255,99,132,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: temperatureArray
                }]
        };

        // get average of temperature and humidity two decimal places
        const averageHumidity = humidityArray.reduce((a, b) => a + b, 0) / humidityArray.length;
        const averageTemperature = temperatureArray.reduce((a, b) => a + b, 0) / temperatureArray.length;

        // get max and min of temperature and humidity
        const maxHumidity = Math.max(...humidityArray);
        const minHumidity = Math.min(...humidityArray);
        const maxTemperature = Math.max(...temperatureArray);
        const minTemperature = Math.min(...temperatureArray);

        // get count per unique value of temperature and humidity
        const countHumidity = humidityArray.reduce((a, b) => {
            a[b] = (a[b] || 0) + 1;
            return a;
        }, {});
        const countTemperature = temperatureArray.reduce((a, b) => {
            a[b] = (a[b] || 0) + 1;
            return a;
        }, {});

        // get standard deviation of temperature
        const varianceTemperature = temperatureArray.reduce((a, b) => a + Math.pow(b - averageTemperature, 2), 0) / temperatureArray.length;
        const standardDeviationTemperature = Math.sqrt(varianceTemperature);

        // get standard deviation of humidity
        const varianceHumidity = humidityArray.reduce((a, b) => a + Math.pow(b - averageHumidity, 2), 0) / humidityArray.length;
        const standardDeviationHumidity = Math.sqrt(varianceHumidity);


        // make two pie chart for countHumidity and countTemperature
        const dataHumidityPie = {
            labels: Object.keys(countHumidity),
            datasets: [{
                data: Object.values(countHumidity),
                backgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56'
                ],
                hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56'
                ]
            }]
        };

        const dataTemperaturePie = {
            labels: Object.keys(countTemperature),
            datasets: [{
                data: Object.values(countTemperature),
                backgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56'
                ],
                hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56'
                ]
            }]
        };

        // make two bar chart for countHumidity and countTemperature
        const dataHumidityBar = {
            labels: Object.keys(countHumidity),
            datasets: [
                {
                    label: 'Humidity',
                    backgroundColor: 'rgba(255,99,132,0.2)',
                    borderColor: 'rgba(255,99,132,1)',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                    hoverBorderColor: 'rgba(255,99,132,1)',
                    data: Object.values(countHumidity)
                }
            ]
        };

        const dataTemperatureBar = {
            labels: Object.keys(countTemperature),
            datasets: [
                {
                    label: 'Temperature',
                    backgroundColor: 'rgba(255,99,132,0.2)',
                    borderColor: 'rgba(255,99,132,1)',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                    hoverBorderColor: 'rgba(255,99,132,1)',
                    data: Object.values(countTemperature)
                }
            ]
        };

        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-center">
                            <h1>Weather Data</h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <h2>Temperature</h2>
                        <div className="row">
                            <div className="col-md-6">
                                <h3>Average: {averageTemperature.toFixed(2)}</h3>
                                <h3>Max: {maxTemperature}</h3>
                                <h3>Min: {minTemperature}</h3>
                                <h3>Standard Deviation: {standardDeviationTemperature.toFixed(2)}</h3>
                            </div>
                            <div className="col-md-6">
                                <Pie data={dataTemperaturePie} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <Bar data={dataTemperatureBar} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h2>Humidity</h2>
                        <div className="row">
                            <div className="col-md-6">
                                <h3>Average: {averageHumidity.toFixed(2)}</h3>
                                <h3>Max: {maxHumidity}</h3>
                                <h3>Min: {minHumidity}</h3>
                                <h3>Standard Deviation: {standardDeviationHumidity.toFixed(2)}</h3>
                            </div>
                            <div className="col-md-6">
                                <Pie data={dataHumidityPie} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <Bar data={dataHumidityBar} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default chart;